import { render } from "./Pengaturan.vue?vue&type=template&id=2c226a23"
import script from "./Pengaturan.vue?vue&type=script&lang=js"
export * from "./Pengaturan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\forteapp-sales\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBanner,QBtn,QScrollArea,QInput,QIcon,QCardActions});
